import { DesignRoomDetailsFormModel } from '../shared/quote-or-design-form/rooms/designRoomDetailsFormModel';

export type DesignRoomDetailsResponse = {
  unheatedAreaInMetresSquared: number | null;
  voidAreaInMetresSquared: number | null;
  pipesPerPort: number | null;
  manifoldDistanceInMetres: number | null;
  verticalRunbackInMetres: number | null;
  estimatedLengthOfEachPipeInMetres: number | null;
  drawnLengthInMetres: number | null;
  oversupplyLengthInMetres: number | null;
  peripheralAreaInMetresSquared: number | null;
  turnPanelQuantity: number | null;
  straightPanelQuantity: number | null;
  plateAreaInMetresSquared: number | null;
  hasPanelsForUnheatedArea: boolean;
  temperatureDeltaInDegreesCelsius: number | null;
  maximumTemperatureInDegreesCelsius: number | null;
  screedDetails: RoomScreedDetailsResponse | null;
};

export type RoomScreedDetailsResponse = {
  screedConductivity: number | null;
  thicknessOfScreedAbovePipeInMillimetres: number | null;
};

export const mapDesignRoomDetailsResponseToFormModel = (
  response: DesignRoomDetailsResponse,
): DesignRoomDetailsFormModel => ({
  unheatedAreaInMetresSquared: response.unheatedAreaInMetresSquared?.toString() ?? '',
  voidAreaInMetresSquared: response.voidAreaInMetresSquared?.toString() ?? '',
  pipesPerPort: response.pipesPerPort?.toString() ?? '',
  manifoldDistanceInMetres: response.manifoldDistanceInMetres?.toString() ?? '',
  verticalRunbackInMetres: response.verticalRunbackInMetres?.toString() ?? '',
  estimatedLengthOfEachPipeInMetres: response.estimatedLengthOfEachPipeInMetres,
  drawnLengthInMetres: response.drawnLengthInMetres?.toString() ?? '',
  oversupplyLengthInMetres: response.oversupplyLengthInMetres?.toString() ?? '',
  peripheralAreaInMetresSquared: response.peripheralAreaInMetresSquared?.toString() ?? '',
  turnPanelQuantity: response.turnPanelQuantity?.toString() ?? '',
  straightPanelQuantity: response.straightPanelQuantity?.toString() ?? '',
  plateAreaInMetresSquared: response.plateAreaInMetresSquared?.toString() ?? '',
  hasPanelsForUnheatedArea: response.hasPanelsForUnheatedArea,
  temperatureDeltaInDegreesCelsius: response.temperatureDeltaInDegreesCelsius?.toString() ?? '',
  maximumTemperatureInDegreesCelsius: response.maximumTemperatureInDegreesCelsius?.toString() ?? '',
  screedDetails:
    response.screedDetails == null
      ? null
      : {
          screedConductivity: response.screedDetails.screedConductivity?.toString() ?? '',
          thicknessOfScreedAbovePipeInMillimetres:
            response.screedDetails.thicknessOfScreedAbovePipeInMillimetres?.toString() ?? '',
        },
});
